import { useState } from "react";
import { uploadDesignDocVersion } from "../../api/design";

export default function DesignDocVerUpload({ documentId, onUploaded }) {
  const [file, setFile] = useState(null);
  const [version, setVersion] = useState("");
  const [comment, setComment] = useState("");

  const handleUpload = async () => {
    if (!file || !version) {
      alert("파일과 버전을 입력하세요.");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("version", version);
    formData.append("comment", comment);

    try {
      await uploadDesignDocVersion(documentId, formData);
      alert("새 버전 업로드 완료!");
      setFile(null);
      setVersion("");
      setComment("");
      if (onUploaded) onUploaded();
    } catch (err) {
      console.error("버전 업로드 실패", err.response?.data || err);
      alert("업로드 실패");
    }
  };

  return (
    <div className="space-y-4 border rounded-lg p-4 bg-white shadow-sm">
      {/* 제목 */}
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold text-slate-700">
          새 버전 업로드
        </span>
        {/* <span className="text-xs text-slate-500">(읽기 전용 문서 교체)</span> */}
      </div>

      {/* 파일 업로드 */}
      <input
        type="file"
        onChange={(e) => setFile(e.target.files[0])}
        className="block w-full text-sm text-slate-600 file:mr-3 file:rounded-lg file:border-0 file:bg-indigo-50 file:px-3 file:py-1 file:text-indigo-700 hover:file:bg-indigo-100"
      />

      {/* 버전 입력 */}
      <input
        type="text"
        value={version}
        onChange={(e) => setVersion(e.target.value)}
        placeholder="버전 (예: v2.0)"
        className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500"
      />

      {/* 코멘트 */}
      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="코멘트"
        rows={3}
        className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500"
      />

      {/* 업로드 버튼 */}
      <button
        onClick={handleUpload}
        className="w-full rounded-lg bg-indigo-600 px-4 py-2 text-white shadow hover:bg-indigo-700 transition"
      >
        업로드
      </button>
    </div>
  );
}
